const { createClient } = supabase;

const S_URL = "https://ifuvvhdpybadqhcmzzli.supabase.co";
const S_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImlmdXZ2aGRweWJhZHFoY216emxpIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTcxNTI0MzMsImV4cCI6MjA3MjcyODQzM30.IUxlp--5W6jTefRGTolpoJDfRrTXw2uAJxdCFqUpOSY";


const supabaseClient = createClient(S_URL, S_KEY);

export {
  supabaseClient
};